const searchFormValue = {
    project_id: null,
    campaign_id: null,
    is_active: null,
};

const activeFlagOptions = [
    {text: '전체', value: null},
    {text: '활성', value: true},
    {text: '비활성', value: false},
];

const isActiveOption = [
    {text: '활성', value: true},
    {text: '비활성', value: false},
];


const columns = [
    // DS 표 규칙: No. → 메인(상세 창 링크) → 데이터 → 상세 아이콘. 행 44 고정이라 긴 값은 줄이고 title 로 전체를 보인다.
    // No. 는 표시 순서(페이지를 넘어 이어짐, fetchData 에서 매김) — 식별자가 아니다
    {key: 'index', label: 'No.', thClass: 'ds-cell-no', tdClass: 'ds-cell-no', thStyle: {width: '64px'}},
    {key: 'name', label: '규칙셋명'},
    {key: 'root_rule_group', label: '연결 규칙 그룹'},
    {key: 'project_id', label: '프로젝트'},
    {key: 'campaign_id', label: '캠페인'},
    {key: 'is_active', label: '활성', thStyle: {width: '88px'}},
    {
        // 이 규칙셋이 속한 프로젝트로 지금 평가 신청이 가능한 상태인지.
        // 규칙셋과 입력키는 서로 다른 탭에서 따로 등록되고 순서 강제가 없어서,
        // 규칙만 만들고 입력키를 빠뜨린 프로젝트가 조용히 만들어질 수 있다.
        // 그 경우 신청자 전원이 실패하므로 목록에서 바로 보이게 한다.
        key: 'readiness',
        label: '신청 가능',
        thStyle: {width: '120px'},
    },
    {key: 'updated_at', label: '수정일시', tdClass: 'ds-cell-nowrap', thStyle: {width: '160px'}},
    // 아이콘 28 + 좌우 16 = 60
    {key: 'detail', label: '상세', tdClass: 'text-right', thStyle: {width: '60px'}},
];

// 프리셋 마법사: 기업 규모 규칙그룹 검색어 및 라벨 추출
const RULE_GROUP_SIZE_SEARCH = '기업 규모';
// '기업 규모(대기업)' → '대기업'. 괄호가 없으면 전체 이름을 라벨로 사용.
const extractSizeLabel = (name) => {
    if (!name) return '';
    const m = String(name).match(/\(([^)]+)\)/);
    return m ? m[1].trim() : String(name).trim();
};

export {searchFormValue, columns, activeFlagOptions, isActiveOption, RULE_GROUP_SIZE_SEARCH, extractSizeLabel};
